import HcmData from "../hcm/hcmData";
import Contact_us from "../../contact_us/contact_us";
// import TopBar from "../../topbar/topbar";
import Footer from "../../Footer/Footer";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import "../hcm/hcm.css";
export default function Job4() {
  const solutionsAndServicesRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Scroll to the solutionsAndServicesRef element if it exists
    if (solutionsAndServicesRef.current) {
      solutionsAndServicesRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [location]);

  const handleGoBack = () => {
    window.history.back(); // Go back in the browser's history
  };
  return (
    <div>
      {/* <TopBar /> */}
      <HcmData
        scrollTo={solutionsAndServicesRef}
        onClickButton={handleGoBack}
        isButton="Go Back"
      />
      <HcmData heading="Job Description:" />
      <div className="normText">
        Title: Vice President – Customer Success (Global)
      </div>
      <div className="normText">Location: Round Rock, Texas</div>
      <div className="normText">Duration: Full-Time, Permanent</div>

      <HcmData heading="Summary:" />

      <div className="normText">
        Ampliworks Technologies seeks a Vice President – Customer Success
        (Global) to lead the delivery and execution of large-scale enterprise
        software implementation and digital transformation initiatives.
      </div>

      <HcmData heading="Job Duties:" />

      <div className="normText">
        • Lead the delivery and execution of large-scale enterprise software
        implementation and digital transformation initiatives, including ERP
        and HCM systems, cloud-based enterprise applications, Manufacturing
        Execution Systems (MES), Product Lifecycle Management (PLM) systems,
        AI-powered manufacturing operations solutions, and application
        modernization programs.
      </div>
      <div className="normText">
        • Apply deep domain knowledge of manufacturing and supply chain
        operations to support enterprise technology transformation initiatives
        involving ERP, HCM, manufacturing, logistics, and enterprise
        integration technologies.
      </div>
      <div className="normText">
        • Engage with client stakeholders to assess business requirements and
        design technology solutions involving enterprise platforms such as ERP
        systems, including SAP and Oracle, HCM platforms, including UKG/Kronos
        and SuccessFactors, and related enterprise applications.
      </div>
      <div className="normText">
        • Design and oversee solution architecture, including system
        integration, data flows, and interoperability between enterprise
        applications using integration technologies such as APIs, middleware
        platforms, or cloud-based integration tools, including Dell Boomi, SAP
        CPI, or similar technologies.
      </div>
      <div className="normText">
        • Lead cloud migration and transformation initiatives, including
        migration of legacy systems to cloud-based environments and adoption of
        modern architectures.
      </div>
      <div className="normText">
        • Oversee end-to-end project delivery, including solution design,
        implementation, integration, testing, deployment, and post-production
        support for enterprise systems.
      </div>
      <div className="normText">
        • Manage and coordinate global, cross-functional delivery teams,
        including onsite and offshore consultants, to ensure high-quality and
        timely execution of projects.
      </div>
      <div className="normText">
        • Identify and mitigate technical, operational, and delivery risks,
        ensuring resolution of complex project and system integration issues.
      </div>
      <div className="normText">
        • Collaborate with sales and business development teams to support
        pre-sales activities, including solution design, effort estimation,
        development of proposals and statements of work, and participation in
        client presentations.
      </div>
      <div className="normText">
        • Provide leadership in account management, including developing client
        relationships, conducting business reviews, and identifying
        opportunities for expansion of services.
      </div>
      <div className="normText">
        • Support business growth by fostering technology and OEM partner
        relationships, participating in industry events, and helping build
        Ampliworks’ brand awareness and internal capabilities in line with
        evolving industry trends and technologies.
      </div>
      <div className="normText">
        • Oversee budgeting, forecasting, and resource planning for customer
        engagements and delivery operations.
      </div>
      <div className="normText">
        • Contribute to organizational growth by refining delivery
        methodologies, processes, and tools, and mentoring technical and
        functional team members.
      </div>

      <HcmData heading="Minimum Requirements:" />

      <div className="normText">
        Bachelor’s degree in Computer Science, Information Systems,
        Engineering, or a closely related field, plus five (5) years of
        progressive post-baccalaureate experience in the offered position or a
        related role.
      </div>

      <HcmData heading="Travel:" />

      <div className="normText">
        Up to 50% domestic and international travel required.
      </div>

      <HcmData heading="Contact:" />

      <div className="normText">Hanuman P. Chittem, CEO</div>
      <div className="normText">Ampliworks Technologies</div>
      <div className="normText">
        <a href="mailto:hanuman@ampliworks.com">hanuman@ampliworks.com</a>
      </div>

      <Contact_us />
      <Footer />
    </div>
  );
}
